import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import {
  alertReducer,
  authReducer,
  contentReducer,
  fundReducer,
  investmentsReducer,
  marketReducer,
  orderReducer,
  settingReducer,
  subAccountsReducer,
  tradingReducer,
  transferReducer,
  commonReducer,
  corporateReducer,
  fundReportReducer,
  individualReducer,
  fundInvestmentReducer,
  constantReducer,
  notificationReducer,
} from './slices';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['common', 'content', 'constant'],
};

const rootReducer = combineReducers({
  content: contentReducer,
  auth: authReducer,
  investments: investmentsReducer,
  setting: settingReducer,
  trading: tradingReducer,
  transfer: transferReducer,
  subAccounts: subAccountsReducer,
  order: orderReducer,
  market: marketReducer,
  fund: fundReducer,
  alert: alertReducer,
  common: commonReducer,
  corporate: corporateReducer,
  individual: individualReducer,
  fundReport: fundReportReducer,
  fundInvestment: fundInvestmentReducer,
  constant: constantReducer,
  notification: notificationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
